export class CaCalculationListModel {
  id: number;
  assets: string;
  assetsCategory: string;
}
